<div class="mx-auto p-4 md:p-8 bg-white rounded-lg shadow-sm flex flex-col lg:flex-row gap-8">

  <!-- Coluna da Esquerda: Controles da Venda -->
  <div class="w-full lg:w-1/2 space-y-6">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="flex flex-col">
        <label class="mb-1 font-medium text-gray-700">Status da Venda</label>
        
        <div class="flex flex-wrap gap-4 mt-2">
          <label *ngFor="let status of statusOptions" class="flex items-center space-x-2">
            <input type="radio" name="vendaSituacao" [(ngModel)]="venda.vendaSituacao" [value]="status.value" class="h-4 w-4" />
            <span>{{ status.label }}</span>
          </label>
        </div>
      </div>

    </div>
    
        <form (ngSubmit)="addProduct()" class="space-y-4">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label for="product-search" class="block text-sm font-medium text-gray-700 mb-1">Buscar Produto</label>
            <p-autoComplete 
            id="product-search" 
            [(ngModel)]="selectedProduct" 
            [suggestions]="optionsProducts" 
            field="label" 
            (completeMethod)="searchProduct($event)" 
            placeholder="Digite para buscar..." 
            styleClass="w-full" 
            [ngModelOptions]="{ standalone: true }"
            >
          </p-autoComplete>
          </div>

          <!-- Vendedor -->
          <div class="flex flex-col">
            <label for="vendedor" class="block text-sm font-medium text-gray-700 mb-1">Vendedor</label>
            <p-dropdown
              [options]="vendedores"
              optionLabel="nome"
              [(ngModel)]="selectedVendedor"
              name="vendedor"
              placeholder="Selecione um vendedor"
              class="w-full"
            ></p-dropdown>
          </div>
      </div>
      <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">

        <div class="flex flex-col">
          <label for="quantidade" class="block text-sm font-medium text-gray-700 mb-1">Quantidade</label>
          <p-inputNumber
          inputId="quantidade"
          placeholder="Qtd"
          name="quantidade"
          [(ngModel)]="itemVenda.quantidade"
            [minFractionDigits]="0"
            [maxFractionDigits]="3"
          styleClass="w-full"></p-inputNumber>
        </div>

        <div class="flex flex-col">
          <label for="acrescimo" class="block text-sm font-medium text-gray-700 mb-1">Acréscimo</label>
          <p-inputNumber inputId="acrescimo" [(ngModel)]="itemVenda.valorAcrescimo" name="acrescimo" placeholder="Acréscimo" mode="currency" currency="BRL" styleClass="w-full"></p-inputNumber>
        </div>
        <div class="flex flex-col">
          <label for="desconto" class="block text-sm font-medium text-gray-700 mb-1">Desconto</label>
          <p-inputNumber inputId="desconto" [(ngModel)]="itemVenda.valorDesconto" name="desconto" placeholder="Desconto" mode="currency" currency="BRL" styleClass="w-full"></p-inputNumber>
        </div>
      </div>

      <button pButton type="submit" label="Adicionar" [disabled]="!selectedProduct.value || itemVenda.quantidade <= 0"></button>
    </form>
  </div>

  <!-- Coluna da Direita: Itens e Total -->
  <div class="w-full lg:w-1/2 space-y-4">
    <h2 class="text-xl font-semibold">Produtos Selecionados</h2>
    <div class="overflow-x-auto min-h-[200px]">
      <p-table [value]="venda.itens" class="w-full">
        <ng-template pTemplate="header">
          <tr>
            <th class="p-2 border-b">Produto</th>
            <th class="p-2 border-b">Qtd</th>
            <th class="p-2 border-b">Preço</th>
            <th class="p-2 border-b">Total</th>
            <th class="p-2 border-b">Ação</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-itemvenda let-i="rowIndex">
          <tr>
            <td class="p-2 border-b">{{ itemvenda.produto.nome }}</td>
            <td class="p-2 border-b">{{ itemvenda.quantidade }}</td>
            <td class="p-2 border-b">{{ itemvenda.produto.preco | currency:'BRL' }}</td>
            <td class="p-2 border-b">{{ itemvenda.valorTotal | currency:'BRL' }}</td>
            <td class="p-2 border-b">
              <button pButton type="button" icon="pi pi-trash" class="p-button-danger p-button-sm" (click)="removerItem(i)"></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="text-right space-y-1">
      <p class="text-lg text-gray-700">Subtotal: {{ venda.subtotal | currency:'BRL' }}</p>
      <p class="text-lg text-gray-700">Acréscimo: {{ venda.acrescimo | currency:'BRL' }}</p>
      <p class="text-lg text-gray-700">Desconto: {{ venda.desconto | currency:'BRL' }}</p>
      <p class="text-xl font-bold text-gray-800">Total: {{ venda.total | currency:'BRL' }}</p>
    </div>

    <div class="flex flex-wrap gap-4">
      <button pButton label="Finalizar Venda" (click)="finalizeSale()" [disabled]="venda.itens.length == 0"></button>
      <button pButton label="Cancelar" (click)="cancelSale()" class="p-button-danger"></button>
    </div>
  </div>
</div>

<app-pagamento-modal [venda]="venda" [display]="showModalPagamento" (onClose)="showModalPagamento = false" (onConfirm)="confirmSale($event)"></app-pagamento-modal>
